import * as types from 'store/modules/hrmsLovCodcomp/mutation-types'
import hrmsLovCodcomp from 'api/hrmsLovCodcomp'
import swal from 'sweetalert'
import hrmsLovCodcompLabels from 'assets/labels/hrmsLov'
import { hrmsLovCodcompColumns } from 'assets/columns/hrmsLovCodcomp'
import configLabel from 'src/../config/label'
import env from 'src/../env.js'

export default {
  state: {
    popupLovCodcomp: {
      total: 0,
      rows: [],
      lang: window.localStorage.getItem(env.site + '_lang')
    },
    lovCodcompCurrentDesc: function (code) {
      let rowIndex = this.$store.getters[types.GET_LOV_CODCOMP].rows.map(function (lov) {
        return lov.codcomp
      }).indexOf(code)
      if (rowIndex >= 0) {
        if (typeof this.$store.getters[types.GET_LOV_CODCOMP].rows[rowIndex] !== 'undefined') {
          return this.$store.getters[types.GET_LOV_CODCOMP].rows[rowIndex]['desc_codcomp']
        }
      }
      return ''
    },
    popupLovCodcompColumns: hrmsLovCodcompColumns(),
    popupLovCodcompLabels: hrmsLovCodcompLabels,
    isLoading: false
  },
  getters: {
    [types.GET_LOV_CODCOMP_COLUMNS] (state) {
      return state.popupLovCodcompColumns
    },
    [types.GET_LOV_CODCOMP_LABELS] (state) {
      return state.popupLovCodcompLabels
    },
    [types.GET_LOV_CODCOMP] (state) {
      return state.popupLovCodcomp
    },
    [types.GET_LOV_CODCOMP_CURRENT_DESC] (state) {
      return state.lovCodcompCurrentDesc
    },
    [types.GET_LOV_CODCOMP_IS_LOADING] (state) {
      return state.isLoading
    }
  },
  mutations: {
    [types.SET_LOV_CODCOMP_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.popupLovCodcompColumns[keyLang].popup = configLabel.replaceLabelToColumns(state.popupLovCodcompColumns[keyLang].popup, labels[keyLang])
      }
    },
    [types.SET_LOV_CODCOMP_LABELS] (state, labels) {
      state.popupLovCodcompLabels = labels
    },
    [types.SET_LOV_CODCOMP_IS_LOADING] (state, isLoading) {
      state.isLoading = isLoading
    },
    [types.SET_LOV_CODCOMP] (state, popupLovCodcomp) {
      let nowLang = window.localStorage.getItem(env.site + '_lang')
      popupLovCodcomp.lang = nowLang
      for (var i = 0; i < popupLovCodcomp.rows.length; i++) {
        let lovCodcomp = popupLovCodcomp.rows[i]
        popupLovCodcomp.rows[i].v_codcomp = lovCodcomp.codcomp.substring(0, lovCodcomp.comlevel * 3)
        switch (nowLang) {
          case 'en':
            popupLovCodcomp.rows[i].desc_codcomp = lovCodcomp.namcenteng
            break
          case 'th':
            popupLovCodcomp.rows[i].desc_codcomp = lovCodcomp.namcenttha
            break
          case '103':
            popupLovCodcomp.rows[i].desc_codcomp = lovCodcomp.namcent3
            break
          case '104':
            popupLovCodcomp.rows[i].desc_codcomp = lovCodcomp.namcent4
            break
          case '105':
            popupLovCodcomp.rows[i].desc_codcomp = lovCodcomp.namcent5
            break
        }
      }
      state.popupLovCodcomp = popupLovCodcomp
    }
  },
  actions: {
    [types.RECEIVED_LOV_CODCOMP_COLUMNS_LABELS] ({ state, commit }) {
      if (state.popupLovCodcomp.total <= 0) {
        hrmsLovCodcomp.getLovCodcompLabels()
          .then((response) => {
            const data = JSON.parse(response.request.response)
            commit(types.SET_LOV_CODCOMP_COLUMNS, data.labels)
            commit(types.SET_LOV_CODCOMP_LABELS, data.labels)
          })
          .catch((error) => {
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
      }
    },
    [types.RECEIVED_LOV_CODCOMP] ({ state, commit }) {
      if (state.popupLovCodcomp.total <= 0) {
        commit(types.SET_LOV_CODCOMP_IS_LOADING, true)
        hrmsLovCodcomp.getLovCodcomp()
          .then((response) => {
            const data = JSON.parse(response.request.response)
            commit(types.SET_LOV_CODCOMP, data)
            commit(types.SET_LOV_CODCOMP_IS_LOADING, false)
          })
          .catch((error) => {
            commit(types.SET_LOV_CODCOMP_IS_LOADING, false)
            let message = error
            if (error.response) {
              const data = error.response.data
              message = data.response
            }
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          })
      } else if (state.popupLovCodcomp.lang !== window.localStorage.getItem(env.site + '_lang')) {
        commit(types.SET_LOV_CODCOMP, state.popupLovCodcomp)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrmsLovCodcomp/index.js